// Edge Function callers used by the UI (not by the cron).
//
// Each helper:
//   - Pulls the user's session for the bearer header.
//   - POSTs to the named function with a typed body.
//   - Returns parsed JSON or throws.

import { sb } from "./db.ts";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;

async function callFunction<T>(name: string, body: unknown): Promise<T> {
  const { data: { session } } = await sb.auth.getSession();
  if (!session) throw new Error("Not signed in.");
  const res = await fetch(`${SUPABASE_URL}/functions/v1/${name}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${session.access_token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  const text = await res.text();
  if (!res.ok) {
    let msg = text;
    try { msg = JSON.parse(text).error ?? text; } catch { /* not JSON */ }
    throw new Error(`${name}: ${res.status} — ${msg}`);
  }
  return JSON.parse(text) as T;
}

export async function approveChange(
  change_id: number,
  note?: string,
): Promise<{ ok: boolean; applied: Record<string, unknown> }> {
  return callFunction("curation-action", { action: "approve", change_id, note });
}

export async function rejectChange(
  change_id: number,
  note?: string,
): Promise<{ ok: boolean }> {
  return callFunction("curation-action", { action: "reject", change_id, note });
}

export async function ingestUrl(url: string): Promise<{
  ok: boolean;
  matched_topic_id: number | null;
  proposed_change_id: number | null;
  message?: string;
}> {
  return callFunction("ingest-url", { url });
}
